import { render, staticRenderFns } from "./MainSpinner.vue?vue&type=template&id=2914707a&scoped=true&"
import script from "./MainSpinner.vue?vue&type=script&lang=js&"
export * from "./MainSpinner.vue?vue&type=script&lang=js&"
import style0 from "./MainSpinner.vue?vue&type=style&index=0&id=2914707a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2914707a",
  null
  
)

export default component.exports